import { c as _c } from "react/compiler-runtime";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import { STATEMENT_TYPE } from "@/helpers/Types";
import DiscordIcon from "./DiscordIcon";
import EmailIcon from "./EmailIcon";
import FacebookIcon from "./FacebookIcon";
import LinkedInIcon from "./LinkedInIcon";
import PhoneIcon from "./PhoneIcon";
import TelegramIcon from "./TelegramIcon";
import WeChatIcon from "./WeChatIcon";
import WebsiteIcon from "./WebsiteIcon";
import XIcon from "./XIcon";
import TikTokIcon from "./TikTokIcon";
import GithubIcon from "./GithubIcon";
import RedditIcon from "./RedditIcon";
import InstagramIcon from "./InstagramIcon";
import WeiboIcon from "./WeiboIcon";
import SubstackIcon from "./SubstackIcon";
import MediumIcon from "./MediumIcon";
import MirrorIcon from "./MirrorIcon";
import YoutubeIcon from "./YoutubeIcon";
import LinktreeIcon from "./LinktreeIcon";
import LinkIcon from "./LinkIcon";
import BioIcon from "./BioIcon";
import SuperRareIcon from "./SuperRareIcon";
import FoundationIcon from "./FoundationIcon";
import MakersPlaceIcon from "./MakersPlaceIcon";
import KnownOriginIcon from "./KnownOriginIcon";
import PepeWTFIcon from "./PepeWTFIcon";
import OpenseaIcon from "./OpenseaIcon";
import ArtBlocksIcon from "./ArtBlocksIcon";
import DecaArtIcon from "./DecaArtIcon";
import OnCyberIcon from "./OnCyberIcon";
import TheLineIcon from "./TheLineIcon";
import ManifoldIcon from "./ManifoldIcon";
import TransientIcon from "./TransientIcon";
export default function SocialStatementIcon(t0) {
  const $ = _c(33);
  const {
    statementType
  } = t0;
  switch (statementType) {
    case STATEMENT_TYPE.X:
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <XIcon aria-hidden="true" />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case STATEMENT_TYPE.FACEBOOK:
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <FacebookIcon aria-hidden="true" />;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case STATEMENT_TYPE.LINKED_IN:
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <LinkedInIcon aria-hidden="true" />;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case STATEMENT_TYPE.INSTAGRAM:
      {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <InstagramIcon aria-hidden="true" />;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case STATEMENT_TYPE.TIK_TOK:
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <TikTokIcon aria-hidden="true" />;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
    case STATEMENT_TYPE.GITHUB:
      {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <GithubIcon aria-hidden="true" />;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case STATEMENT_TYPE.REDDIT:
      {
        let t1;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <RedditIcon aria-hidden="true" />;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
    case STATEMENT_TYPE.WEIBO:
      {
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <WeiboIcon aria-hidden="true" />;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case STATEMENT_TYPE.SUBSTACK:
      {
        let t1;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <SubstackIcon aria-hidden="true" />;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
    case STATEMENT_TYPE.MEDIUM:
      {
        let t1;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <MediumIcon aria-hidden="true" />;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    case STATEMENT_TYPE.MIRROR_XYZ:
      {
        let t1;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <MirrorIcon aria-hidden="true" />;
          $[10] = t1;
        } else {
          t1 = $[10];
        }
        return t1;
      }
    case STATEMENT_TYPE.YOUTUBE:
      {
        let t1;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <YoutubeIcon aria-hidden="true" />;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    case STATEMENT_TYPE.LINKTREE:
      {
        let t1;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <LinktreeIcon />;
          $[12] = t1;
        } else {
          t1 = $[12];
        }
        return t1;
      }
    case STATEMENT_TYPE.DISCORD:
      {
        let t1;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <DiscordIcon aria-hidden="true" />;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
    case STATEMENT_TYPE.TELEGRAM:
      {
        let t1;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <TelegramIcon aria-hidden="true" />;
          $[14] = t1;
        } else {
          t1 = $[14];
        }
        return t1;
      }
    case STATEMENT_TYPE.WECHAT:
      {
        let t1;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <WeChatIcon aria-hidden="true" />;
          $[15] = t1;
        } else {
          t1 = $[15];
        }
        return t1;
      }
    case STATEMENT_TYPE.PHONE:
      {
        let t1;
        if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <PhoneIcon aria-hidden="true" />;
          $[16] = t1;
        } else {
          t1 = $[16];
        }
        return t1;
      }
    case STATEMENT_TYPE.EMAIL:
      {
        let t1;
        if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <EmailIcon aria-hidden="true" />;
          $[17] = t1;
        } else {
          t1 = $[17];
        }
        return t1;
      }
    case STATEMENT_TYPE.WEBSITE:
      {
        let t1;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <WebsiteIcon aria-hidden="true" />;
          $[18] = t1;
        } else {
          t1 = $[18];
        }
        return t1;
      }
    case STATEMENT_TYPE.LINK:
      {
        let t1;
        if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <LinkIcon aria-hidden="true" />;
          $[19] = t1;
        } else {
          t1 = $[19];
        }
        return t1;
      }
    case STATEMENT_TYPE.BIO:
      {
        let t1;
        if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <BioIcon aria-hidden="true" />;
          $[20] = t1;
        } else {
          t1 = $[20];
        }
        return t1;
      }
    case STATEMENT_TYPE.SUPER_RARE:
      {
        let t1;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <SuperRareIcon aria-hidden="true" />;
          $[21] = t1;
        } else {
          t1 = $[21];
        }
        return t1;
      }
    case STATEMENT_TYPE.FOUNDATION:
      {
        let t1;
        if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <FoundationIcon aria-hidden="true" />;
          $[22] = t1;
        } else {
          t1 = $[22];
        }
        return t1;
      }
    case STATEMENT_TYPE.MAKERS_PLACE:
      {
        let t1;
        if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <MakersPlaceIcon aria-hidden="true" />;
          $[23] = t1;
        } else {
          t1 = $[23];
        }
        return t1;
      }
    case STATEMENT_TYPE.KNOWN_ORIGIN:
      {
        let t1;
        if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <KnownOriginIcon aria-hidden="true" />;
          $[24] = t1;
        } else {
          t1 = $[24];
        }
        return t1;
      }
    case STATEMENT_TYPE.PEPE_WTF:
      {
        let t1;
        if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <PepeWTFIcon aria-hidden="true" />;
          $[25] = t1;
        } else {
          t1 = $[25];
        }
        return t1;
      }
    case STATEMENT_TYPE.OPENSEA:
      {
        let t1;
        if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <OpenseaIcon aria-hidden="true" />;
          $[26] = t1;
        } else {
          t1 = $[26];
        }
        return t1;
      }
    case STATEMENT_TYPE.ART_BLOCKS:
      {
        let t1;
        if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ArtBlocksIcon aria-hidden="true" />;
          $[27] = t1;
        } else {
          t1 = $[27];
        }
        return t1;
      }
    case STATEMENT_TYPE.DECA_ART:
      {
        let t1;
        if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <DecaArtIcon aria-hidden="true" />;
          $[28] = t1;
        } else {
          t1 = $[28];
        }
        return t1;
      }
    case STATEMENT_TYPE.ON_CYBER:
      {
        let t1;
        if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <OnCyberIcon aria-hidden="true" />;
          $[29] = t1;
        } else {
          t1 = $[29];
        }
        return t1;
      }
    case STATEMENT_TYPE.THE_LINE:
      {
        let t1;
        if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <TheLineIcon aria-hidden="true" />;
          $[30] = t1;
        } else {
          t1 = $[30];
        }
        return t1;
      }
    case STATEMENT_TYPE.MANIFOLD:
      {
        let t1;
        if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ManifoldIcon />;
          $[31] = t1;
        } else {
          t1 = $[31];
        }
        return t1;
      }
    case STATEMENT_TYPE.TRANSIENT:
      {
        let t1;
        if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <TransientIcon />;
          $[32] = t1;
        } else {
          t1 = $[32];
        }
        return t1;
      }
    default:
      {
        assertUnreachable(statementType);
        return null;
      }
  }
}